var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.6486H4C3.44772 19.6486 3 19.2009 3 18.6486V9.64856H0L10.3273 0.260062C10.7087 -0.0866875 11.2913 -0.0866875 11.6727 0.260062L22 9.64856H19V18.6486C19 19.2009 18.5523 19.6486 18 19.6486ZM5 17.6486H17V7.80601L11 2.35146L5 7.80601V17.6486Z",
    fill: "#6A6E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseOutline);
export default __webpack_public_path__ + "static/media/house-outline.4f7f59e0329540d770b07b1bf2652151.svg";
export { ForwardRef as ReactComponent };